// extracted by mini-css-extract-plugin
export default {"container":"RobotList_container__VY1G5","wrapper":"RobotList_wrapper__1D2Ig","header":"RobotList_header__rx36A","total":"RobotList_total__36v2Y","option":"RobotList_option__MbSq6"};